import { useHistory } from 'react-router-dom';
import { t } from 'ttag';

import DressIcon from '@svg/dress.svg';
import ParfumeIcon from '@svg/parfume.svg';
import MenClothIcon from '@svg/men-cloth.svg';
import PramIcon from '@svg/pram.svg';
import HomeIcon from '@svg/home.svg';
import TeddyLiteIcon from '@svg/teddy-lite.svg';
import SportLiteIcon from '@svg/sport-lite.svg';
import AccessoriesLiteIcon from '@svg/accessories.svg';
import ElectronicsIcon from '@svg/electronics.svg';
import AutoIcon from '@svg/auto.svg';
import PetIcon from '@svg/pet.svg';
import GardenIcon from '@svg/garden.svg';
import BuildingIcon from '@svg/building.svg';
import PurchasesIcon from '@svg/purchases.svg';
import GearIcon from '@svg/gear.svg';
import TestimonialsIcon from '@svg/testimonials.svg';
import BasketIcon from '@svg/basket.svg';
import {
  dialogsList,
  memberProfile,
  myPurchasesIndex,
} from '@urls';
import { getShafaAbsoluteUrl } from '@utils/common';
import { sendProfileMenuOptionEvent } from '@utils/analytics';
import { useBasket } from '@hook/useBasket';

// add here new data if added new root category SHAF-153
export const NAMESPACE_ICONS_MAP: Record<string, React.FC<React.SVGProps<SVGAElement>>> = {
  women: DressIcon,
  men: MenClothIcon,
  kids: PramIcon,
  home: HomeIcon,
  cosmetics: ParfumeIcon,
  forkids: TeddyLiteIcon,
  sport: SportLiteIcon,
  aksesuary: AccessoriesLiteIcon,
  electronics: ElectronicsIcon,
  auto: AutoIcon,
  pet: PetIcon,
  garden: GardenIcon,
  building: BuildingIcon,
};

interface UserMenuLink {
  icon: React.FC<React.SVGProps<SVGAElement>>,
  name: string,
  href: string,
  fill?: string,
  onClick: () => void,
}

export const useUserMenuLinks = () => {
  const history = useHistory();

  const createHref = (url: string) => history.createHref({ pathname: url });

  const links: UserMenuLink[] = [
    {
      icon: PurchasesIcon,
      name: t`Мої покупки`,
      href: getShafaAbsoluteUrl(history.createHref({ pathname: myPurchasesIndex })),
      onClick: () => sendProfileMenuOptionEvent('purchases'),
    },
    {
      icon: GearIcon,
      name: t`Мої налаштування`,
      href: createHref(memberProfile),
      onClick: () => sendProfileMenuOptionEvent('settings'),
    },
  ];

  return links;
};

interface FastLink {
  icon: React.FC<React.SVGProps<SVGAElement>>,
  counter?: number | null,
  indicator?: boolean,
  href?: string,
  onClick?: () => void,
}

interface DesktopFastLinksPayload {
  unreadMessagesCount?: number
  productsCount?: number | null,
}

export const useDesktopFastLinks = ({
  unreadMessagesCount,
  productsCount,
}: DesktopFastLinksPayload) => {
  const history = useHistory();

  const { ui: basketUI } = useBasket({ lazy: true });

  const links: FastLink[] = [
    {
      icon: TestimonialsIcon,
      counter: unreadMessagesCount,
      href: getShafaAbsoluteUrl(history.createHref({ pathname: dialogsList })),
    },
    {
      icon: BasketIcon,
      counter: productsCount,
      onClick: () => basketUI.open(),
    },
  ];

  return links;
};

interface MobileFastLinksPayload {
  productsCount?: number | null,
}

export const useMobileFastLinks = ({
  productsCount,
}: MobileFastLinksPayload) => {
  const { ui: basketUI } = useBasket({ lazy: true });

  const links: FastLink[] = [
    {
      icon: BasketIcon,
      counter: productsCount,
      onClick: () => basketUI.open(),
    },
  ];

  return links;
};
